import '.c7{position:relative;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.e9{flex:1 1 auto;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.q{justify-content:center;}.ssr-plugin'
import '.ea{font-size:1.125rem;}.ssr-plugin'
import '.eb{appearance:none;}.ssr-plugin'
import '.ec{height:2.75rem;}.ssr-plugin'
import '.ed{padding:0.5rem 3rem 0.5rem 1rem;}.ssr-plugin'
import '.aj{text-overflow:ellipsis;}.ssr-plugin'
import '.ee{border-radius:0.75rem;}.ssr-plugin'
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Style, styled } from 'inlines'
import { Text } from '../../typography/Text'
import Column from '@app/components/layout/Column'

export type SelectProps<T extends string | number> = {
  label?: string
  labelStyle?: Style
  value?: T | null
  setValue: (value: T | null) => void
  options: { value: T; label: string }[]
  notSelectedLabel?: string
  variant?: 'outlined' | 'muted-blue'
}

export const NOT_SELECTED_KEY = 'not-selelcted'

export const Select = <T extends string | number>({
  value,
  label,
  labelStyle,
  options,
  notSelectedLabel,
  variant = 'outlined',
  setValue,
}: SelectProps<T>) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const raw = e.target.value
    if (raw === NOT_SELECTED_KEY) {
      setValue(null)
      return
    }
    const match = options.find((o) => String(o.value) === raw)
    setValue(match ? match.value : null)
  }

  return (
    <Column gap={0} alignItems="stretch">
      {label && (
        <Text.Medium
          color="var(--shades-blue-500)"
          style={{ height: '2.125rem', ...labelStyle }}
        >
          {label}
        </Text.Medium>
      )}
      <div className="c7 a e9 b ab q"
      >
        <styled.select className="ea eb ec ed aj ee"
          value={value !== null && value !== undefined ? String(value) : NOT_SELECTED_KEY}
          onChange={handleChange}
          style={{
            border: `1px solid ${variant === 'outlined' ? 'var(--shades-blue-300)' : 'var(--shades-blue-50)'}`,
            background:
              variant === 'outlined'
                ? 'var(--shades-white)'
                : 'var(--shades-blue-50)',
            '&:focus': {
              outline: 'none',
            },
            color: value !== null && value !== undefined ? 'var(--primary-blue)' : 'var(--gray-300)',
          }}
        >
          {notSelectedLabel && (
            <styled.option value={NOT_SELECTED_KEY}>
              {notSelectedLabel}
            </styled.option>
          )}
          {options.map((option) => (
            <styled.option
              key={option.value ?? NOT_SELECTED_KEY}
              value={String(option.value)}
            >
              {option.label}
            </styled.option>
          ))}
        </styled.select>
        <FontAwesomeIcon
          icon={faChevronDown}
          color={
            variant === 'outlined'
              ? 'var(--shades-blue-200)'
              : 'var(--primary-blue)'
          }
          style={{ position: 'absolute', right: '1rem' }}
        />
      </div>
    </Column>
  )
}
